import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Accounts from './pages/Accounts';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import WachtwoordInstellen from './pages/WachtwoordInstellen';
import Dashboard from './pages/Dashboard';
import Objecten from './pages/Objecten';
import Onderhoud from './pages/Onderhoud';
import Werkorders from './pages/Werkorders';
import Logboek from './pages/Logboek';
import Storingen from './pages/Storingen';
import MeldingMaken from './pages/MeldingMaken';
import ObjectDetail from './pages/ObjectDetail';
import Notificaties from './pages/Notificaties';
import NotificatieVoorkeuren from './pages/NotificatieVoorkeuren';
import ScanObject from './pages/ScanObject';
import Tweefactor from './pages/Tweefactor';
import LockScreen from './components/LockScreen';

function ProtectedRoute({ children, recht }) {
  const { info, loading, heeftRecht } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Laden&#8230;</div>;
  if (!info) return <Navigate to="/login" replace />;
  if (recht && !heeftRecht(recht)) return <Navigate to="/" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { info, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Laden&#8230;</div>;
  if (info) return <Navigate to="/" replace />;
  return children;
}

function Gate({ children }) {
  const { vergrendeld } = useAuth();
  if (vergrendeld) return <LockScreen />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Gate>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/wachtwoord-instellen" element={<WachtwoordInstellen />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/objecten" element={<ProtectedRoute recht="objecten:lezen"><Objecten /></ProtectedRoute>} />
          <Route path="/object/:id" element={<ProtectedRoute recht="objecten:lezen"><ObjectDetail /></ProtectedRoute>} />
          <Route path="/onderhoud" element={<ProtectedRoute recht="onderhoud:lezen"><Onderhoud /></ProtectedRoute>} />
          <Route path="/werkorders" element={<ProtectedRoute recht="werkorders:lezen"><Werkorders /></ProtectedRoute>} />
          <Route path="/logboek" element={<ProtectedRoute recht="logboek:lezen"><Logboek /></ProtectedRoute>} />
          <Route path="/storingen" element={<ProtectedRoute recht="storingen:lezen"><Storingen /></ProtectedRoute>} />
          <Route path="/melding" element={<ProtectedRoute recht="storingen:melden"><MeldingMaken /></ProtectedRoute>} />
          <Route path="/notificaties" element={<ProtectedRoute><Notificaties /></ProtectedRoute>} />
          <Route path="/notificatie-voorkeuren" element={<ProtectedRoute><NotificatieVoorkeuren /></ProtectedRoute>} />
          <Route path="/scan" element={<ProtectedRoute recht="objecten:lezen"><ScanObject /></ProtectedRoute>} />
          <Route path="/2fa" element={<ProtectedRoute><Tweefactor /></ProtectedRoute>} />
          <Route path="/beheer" element={<ProtectedRoute recht="accounts:beheren"><Accounts /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </HashRouter>
      </Gate>
    </AuthProvider>
  );
}
